import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import agentsService, { Agent } from '../services/agentsService';
import { Spinner } from './ui';

// Same mapping the sidebar uses: the Doc agent's workspace is the Documents view; every other
// agent renders on the shared engine at /admin/agent/:key.
export const agentHome = (key: string) => (key === 'doc' ? '/admin/docshawk' : `/admin/agent/${key}`);

/**
 * Post-login / index landing. Sends each user to the first agent they're permitted to use, so a
 * Jira-only user lands on the Jira workspace instead of the Doc surface (which they can't access
 * and which used to bounce them back to /login). Admins get all agents, so they land on Doc.
 */
const AgentLanding: React.FC = () => {
  const { logout } = useAuth();
  const [agents, setAgents] = useState<Agent[] | null>(null);

  useEffect(() => {
    let alive = true;
    agentsService.listMyAgents()
      .then(({ agents }) => alive && setAgents(agents))
      .catch(() => alive && setAgents([]));
    return () => { alive = false; };
  }, []);

  if (agents === null) {
    return <div className="mx-card mx-card-pad" style={{ margin: 24 }}><Spinner label="Loading your workspace…" /></div>;
  }
  if (agents.length === 0) {
    return (
      <div className="mx-card mx-card-pad" style={{ maxWidth: 480, margin: 24 }}>
        <div style={{ fontWeight: 600 }}>No agents assigned yet</div>
        <div className="mx-muted" style={{ fontSize: 13, marginTop: 8 }}>
          Your account doesn’t have access to any agents. Ask an administrator to grant you access
          from the Agent Access page.
        </div>
        <button className="mx-btn" style={{ marginTop: 14 }} onClick={logout}>Sign out</button>
      </div>
    );
  }
  return <Navigate to={agentHome(agents[0].key)} replace />;
};

export default AgentLanding;
